import React from 'react'
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from 'configs/AppConfig'

export const publicRoutes = [
    {
        key: 'home',
        path: `${AUTH_PREFIX_PATH}/home`,
        component: React.lazy(() => import('views/land-views/index')),
    },
    {
        key: 'login',
        path: `${AUTH_PREFIX_PATH}/login`,
        component: React.lazy(() => import('views/auth-views/authentication/login')),
    },
    {
        key: 'register',
        path: `${AUTH_PREFIX_PATH}/register`,
        component: React.lazy(() => import('views/auth-views/authentication/register')),
    },
    {
        key: 'forgot-password',
        path: `${AUTH_PREFIX_PATH}/forgot-password`,
        component: React.lazy(() => import('views/auth-views/authentication/forgot-password')),
    },
    {
        key: 'reset',
        path: `${AUTH_PREFIX_PATH}/reset`,
        component: React.lazy(() => import('views/auth-views/authentication/reset')),
    },{
        key: 'callback',
        path: `${AUTH_PREFIX_PATH}/callback`,
        component: React.lazy(() => import('views/auth-views/authentication/aktivasi')),
    },
]

export const protectedRoutes = [
    {
        key: 'dashboard.default',
        path: `${APP_PREFIX_PATH}/dashboards/default`,
        component: React.lazy(() => import('views/app-views/dashboards/default/index')),
    },
    {
        key: 'buat_email',
        path: `${APP_PREFIX_PATH}/buat_email`,
        component: React.lazy(() => import('views/app-views/buat_email/index')),
    },{
        key: 'download_dokumen',
        path: `${APP_PREFIX_PATH}/download_dokumen`,
        component: React.lazy(() => import('views/app-views/download/index')),
    },
]
